import { IconChevronLeft, IconChevronRight } from "@tabler/icons-react"
import React from 'react'

const PaginationControls = ({ currentPage, totalPages, onPageChange }) => {
  const getPageNumbers = () => {
    const pageNumbers: number[] = []
    const maxVisiblePages = 3

    const offset = Math.floor(maxVisiblePages / 2)

    let start = Math.max(1, currentPage - offset)
    let end = Math.min(totalPages, start + maxVisiblePages - 1)
    
    if (end === totalPages) {
      start = Math.max(1, end - maxVisiblePages + 1)
    }

    if (start === 1) {
      end = Math.min(totalPages, start + maxVisiblePages - 1)
    }

    for (let i = start; i <= end; i++) {
      pageNumbers.push(i)
    }

    return pageNumbers
  }

  return (
    <>
      {totalPages > 1 &&
        <div className="flex items-center justify-center gap-2 mt-6">
          <button
            onClick={() => onPageChange(currentPage - 1)}
            disabled={currentPage === 1}
            className="p-2 rounded-lg bg-gray-100 disabled:opacity-50 disabled:cursor-not-allowed"
            aria-label="Previous page"
          >
            <IconChevronLeft className="w-5 h-5" />
          </button>

          {getPageNumbers()[0] > 1 && (
            <>
              <button
                onClick={() => onPageChange(1)}
                className="w-8 h-8 flex items-center justify-center rounded-lg hover:bg-gray-100"
              >
                1
              </button>
              {getPageNumbers()[0] > 2 && (
                <span className="px-1">...</span>
              )}
            </>
          )}

          {getPageNumbers().map(number => (
            <button
              key={number}
              onClick={() => onPageChange(number)}
              className={`w-8 h-8 flex items-center justify-center rounded-lg ${
                currentPage === number 
                  ? 'bg-primary text-white' 
                  : 'hover:bg-gray-100'
              }`}
            >
              {number}
            </button>
          ))}

          {getPageNumbers()[getPageNumbers().length - 1] < totalPages && (
            <>
              {getPageNumbers()[getPageNumbers().length - 1] < totalPages - 1 && (
                <span className="px-1">...</span>
              )}
              <button
                onClick={() => onPageChange(totalPages)}
                className="w-8 h-8 flex items-center justify-center rounded-lg hover:bg-gray-100"
              >
                {totalPages}
              </button>
            </>
          )}

          <button
            onClick={() => onPageChange(currentPage + 1)}
            disabled={currentPage === totalPages}
            className="p-2 rounded-lg bg-gray-100 disabled:opacity-50 disabled:cursor-not-allowed"
            aria-label="Next page"
          >
            <IconChevronRight className="w-5 h-5" />
          </button>
        </div>
      }
    </>
  )
}

export default PaginationControls